module.exports = __webpack_public_path__ + "img/avatar4.39fc265a.png";